import React, { useState, useEffect } from 'react';
import './Side.css';
import { Link } from 'react-router-dom';
import logo from './images/CompanyLogo.svg'

const Sidebar = () => {
    const initialContent = [
        { id: 1, title: 'Course Content', completed: false },
        { id: 2, title: 'Getting started', completed: false },
        { id: 3, title: 'What is DevOps?', completed: false },
        { id: 4, title: 'Outline of this series', completed: false },
        { id: 5, title: 'Introduction to Linux?', completed: false },
        { id: 6, title: 'Intro to git & GitHub', completed: false },
        { id: 7, title: 'Introduction to Docker', completed: false },
        { id: 8, title: 'Introduction to Jenkins', completed: false },
        { id: 9, title: 'Introduction to AWS', completed: false },
        { id: 10, title: 'Introduction to Kubernetes', completed: false },
        { id: 11, title: 'Introduction to Terraform', completed: false },
        { id: 12, title: 'Introduction to Grafana', completed: false },
        { id: 13, title: 'Introduction to Prometheus', completed: false },
    ];

    const [content, setContent] = useState(initialContent);
    const [mainSearchTerm, setMainSearchTerm] = useState('');
    const [subSearchTerm, setSubSearchTerm] = useState('');
    const [activePage, setActivePage] = useState(1);

    useEffect(() => {
        const savedContent = localStorage.getItem('courseContent');
        if (savedContent) {
            setContent(JSON.parse(savedContent));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('courseContent', JSON.stringify(content));
    }, [content]);

    const handleMainSearchChange = (e) => {
        setMainSearchTerm(e.target.value);
    };

    const handleSubSearchChange = (e) => {
        setSubSearchTerm(e.target.value);
    };

    const handleNext = () => {
        if (activePage < content.length) {
            setActivePage(activePage + 1);
        }
    };

    const handlePrevious = () => {
        if (activePage > 1) {
            setActivePage(activePage - 1);
        }
    };

    const handleMarkAsDone = () => {
        setContent(content.map(item => item.id === activePage ? { ...item, completed: true } : item));
    };

    const filteredContent = content.filter(item => item.title.toLowerCase().includes(mainSearchTerm.toLowerCase()));
    const currentPageContent = content.find(item => item.id === activePage);
    const filteredSubContent = content.filter(item => item.title.toLowerCase().includes(subSearchTerm.toLowerCase()));

    return (
        <div className="ssidebar">
            <div className="logo">
                <Link to="/">
                    <img src={logo} className="logoo" alt="Logo" />
                </Link>
                <div className="progresss">
                    <div className="progresss-text">50%</div>
                </div>
            </div>
            <nav>
                <ul>
                    {filteredContent.map(item => (
                        <li
                            key={item.id}
                            style={{ fontWeight: item.id === activePage ? 'bold' : 'normal' }}
                            onClick={() => setActivePage(item.id)}
                        >
                            {item.title} {item.completed && '✔'}
                        </li>
                    ))}
                </ul>
            </nav>

            <header className="hhheader">
                <div className="progresss-container"></div>
                <div className="search-container">
                    <input type="text" className="search-input" placeholder="Search" value={mainSearchTerm} onChange={handleMainSearchChange} />
                    <button className="search-button">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35m1.68-4.32a7.5 7.5 0 11-10.61-10.61 7.5 7.5 0 0110.61 10.61z" />
                        </svg>
                    </button>
                </div>
                <div className="user-icon">
                    <Link to='/ser'>
                        <img src="https://via.placeholder.com/40" alt="User" />
                    </Link>
                </div>
            </header>

            <div className="Appp">
                <header className="hheader">
                    <div className="navvv-buttons">
                        <button className="navvv-button1" onClick={handlePrevious} disabled={activePage === 1}>Previous</button>
                        <button className="navvv-button" onClick={handleNext} disabled={activePage === content.length}>Next</button>
                        <button className="navvv-button" onClick={handleMarkAsDone} style={{ backgroundColor: content.find(item => item.id === activePage)?.completed ? '#4CAF50' : '#222' }}>
                            {content.find(item => item.id === activePage)?.completed ? 'Completed' : 'Mark as done'}
                        </button>
                    </div>
                    <div className="searchh-container">
                        <select className="dropdown" onChange={(e) => setActivePage(Number(e.target.value))} value={activePage}>
                            {filteredSubContent.map(item => (
                                <option key={item.id} value={item.id}>Page: {item.id}</option>
                            ))}
                        </select>
                        {/* <input type="text" className="searchh-input" placeholder="Search by subheading" value={subSearchTerm} onChange={handleSubSearchChange} /> */}
                    </div>
                </header>
                <div className="ontent">
                    <h1>{currentPageContent ? currentPageContent.title : 'Welcome to course!!'}</h1>
                    <div className="course-description">
                        <p>Are you ready to bridge the gap between development and operations? In this course, you'll embark on a journey to master the art of DevOps, a powerful approach that streamlines software delivery and fosters collaboration.</p>
                        <br />
                        <p>Get ready to:</p>
                        <br />
                        <ul>
                            <li>Uncover the DevOps philosophy: Learn how DevOps breaks down silos and promotes a culture of shared responsibility, leading to faster and more reliable software releases.</li>
                            <br />
                            <li>Dive into key DevOps practices: We’ll explore essential practices like continuous integration and continuous delivery (CI/CD), infrastructure as code (IaC), and configuration management.</li>
                            <br />
                            <li>Master essential DevOps tools: Get hands-on experience with industry-standard tools that automate tasks, improve efficiency, and ensure consistent deployments.</li>
                            <br />
                            <li>Become a DevOps champion: Gain the skills and knowledge to implement DevOps principles within your organization, fostering a more agile and collaborative development environment.</li>
                        </ul>
                        <br />
                        <p>This course is designed for anyone who wants to understand and leverage the power of DevOps. Whether you’re a developer, operations professional, or simply curious about modern software development practices, this course will equip you with the knowledge and skills to excel in the ever-evolving IT landscape.</p>
                        <br />
                        <p>Ready to unleash the power of DevOps? Enroll today!</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;


// // src/components/Sidebar.js
// import React from 'react';
// import './Side.css';
// import {Link} from 'react-router-dom';
// // import { FaCog, FaQuestionCircle, FaPlay, FaFileAlt, FaTerminal, FaDocker, FaAws, FaCubes, FaCloud, FaChartBar } from 'react-icons/fa';
// import logo from './images/logo.png';

// const Sidebar = () => {
//     return (
//         <div className="ssidebar">
//             <div className="logo">

//             <Link to="/">
//         <img src={logo} className="logoo" alt="Logo" />
//             </Link>
//                 <div className="progresss">
//             <div className="progresss-text">50%</div>
//           </div> 
//             </div>
//             <nav>
//                 <ul>
//                     <li>Course Content</li>
//                     <li> Getting started</li>
//                     <li> What is DevOps ?</li>
//                     <li> Outline of this series</li>
//                     <li> Introduction to Linux ?</li>
//                     <li> Intro to git & GitHub</li>
//                     <li> Introduction to Docker</li>
//                     <li> Introduction to Jenkins</li>
//                     <li>Introduction to AWS</li>
//                     <li> Introduction to Kubernetes</li>
//                     <li> Introduction to Terraform</li>
//                     <li> Introduction to Grafana</li>
//                     <li> Introduction to Prometheus</li>
//                 </ul>
//                 {/* <ul className="bottomm">
//                     <li> Settings</li>
//                     <li> Help center</li>
//                 </ul> */}
//             </nav>

//             <header className="hhheader">
       
//         <div className="progresss-container">
//           {/* <div className="progress">
//             <div className="progress-text">50%</div>
//           </div> */}
//         </div>
//         <div className="search-container">
//           <input type="text" className="search-input" placeholder="Search" />
//           <button className="search-button">
//             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35m1.68-4.32a7.5 7.5 0 11-10.61-10.61 7.5 7.5 0 0110.61 10.61z" />
//             </svg>
//           </button>
//         </div>
//         <div className="user-icon">
//           <img src="https://via.placeholder.com/40" alt="User" />
//         </div>
//       </header>


//       <div className="Appp">
//       <header className="hheader">
//         <div className="nav-buttons">
//           <button className="nav-button1">Previous</button>
//           <button className="nav-button">Next</button>
//           <button className="nav-button">Mark as done</button>
//         </div>
//         <div className="searchh-container">
//           <select className="dropdown">
//             <option>Page: 1</option>
//             <option>Page: 2</option>
//             <option>Page: 3</option>
//           </select>
//           <input type="text" className="searchh-input" placeholder="Search by subheading" />
//         </div>
//       </header>
//       <div className="content">
//         <h1>Welcome to course!!</h1>
//         <div className="course-description">
//           <p>Are you ready to bridge the gap between development and operations? In this course, you'll embark on a journey to master the art of DevOps, a powerful approach that streamlines software delivery and fosters collaboration.</p>
//           <br />
//           <p>Get ready to:</p>
//           <br />
//           <ul>
//             <li>Uncover the DevOps philosophy: Learn how DevOps breaks down silos and promotes a culture of shared responsibility, leading to faster and more reliable software releases.</li>
//             <br />
//             <li>Dive into key DevOps practices: We’ll explore essential practices like continuous integration and continuous delivery (CI/CD), infrastructure as code (IaC), and configuration management.</li>
//             <br />
//             <li>Master essential DevOps tools: Get hands-on experience with industry-standard tools that automate tasks, improve efficiency, and ensure consistent deployments.</li>
//             <br />
//             <li>Become a DevOps champion: Gain the skills and knowledge to implement DevOps principles within your organization, fostering a more agile and collaborative development environment.</li>
//           </ul>
//           <br />
//           <p>This course is designed for anyone who wants to understand and leverage the power of DevOps. Whether you’re a developer, operations professional, or simply curious about modern software development practices, this course will equip you with the knowledge and skills to excel in the ever-evolving IT landscape.</p>
//           <br />
//           <p>Ready to unleash the power of DevOps? Enroll today!</p>
//         </div>
//         <div className="course-image">
//           {/* <img src="https://via.placeholder.com/600x300" alt="Course illustration" /> */}
//         </div>
//       </div>
//     </div>
//         </div>
//     );
// };

// export default Sidebar;
